'use client';

import { PropsWithChildren } from 'react';
import {
  Tooltip,
  TooltipAnchor,
  TooltipAnchorProps,
  TooltipArrow,
  TooltipStoreProps,
  useTooltipStore,
} from '@ariakit/react';
import DallasTag from '../Tag/DallasTag';

import styles from './DallasTooltipAnchor.module.scss';

interface Props extends Omit<TooltipAnchorProps, 'store' | 'children'> {
  tooltipId?: string;
  tooltip: string;
  tooltipType?: 'label' | 'description';
  tooltipPortal?: boolean;
  render: TooltipAnchorProps['render'];
  tooltipPlacement?: TooltipStoreProps['placement'];
}

export default function DallasTooltipAnchor({
  tooltipId,
  tooltip: text,
  tooltipType: type = 'description',
  tooltipPortal: portal = false,
  render,
  children,
  tooltipPlacement: placement = 'bottom',
}: PropsWithChildren<Props>) {
  const tooltipStore = useTooltipStore({ placement });

  return (
    <>
      <TooltipAnchor store={tooltipStore} render={render}>
        {children}
      </TooltipAnchor>
      <Tooltip
        id={tooltipId}
        className={styles.tooltip}
        store={tooltipStore}
        portal={portal}
      >
        <DallasTag text={text} color="dark" />
        {type === 'description' && <TooltipArrow className={styles.arrow} />}
      </Tooltip>
    </>
  );
}
